import {  Component, ElementRef, EventEmitter, Output, OnInit, OnDestroy, Input, ViewChild} from '@angular/core';
import {Observable, from} from "rxjs";
 
import {Subscription} from "rxjs"; 
import {delay, map} from 'rxjs/operators';
import * as moment from 'moment';
import { Socket } from 'ngx-socket-io';
import {AnalyticService} from '../../../shared/services/analytic.service'
import { NbDialogRef, NbToastrService } from '@nebular/theme';
 
@Component({
  selector: 'app-watch-countdown', 
  templateUrl: './watch-countdown.component.html',
  styleUrls: ['./watch-countdown.component.scss'],
  
})
export class WatchCountdownComponent implements OnInit, OnDestroy{
  
  // @Input() stream_id = false;
   @Input() countData:any;
   @Input() stream:any;
   @Input() cover:any;
   @Output() onDone = new EventEmitter<boolean>();

  days:any = '00'
  hours:any = '00'
  minutes:any = '00'
  seconds:any = '00'
  init:boolean = false

  constructor( ){
  }
   
 
 
   get isEnglish(){
  
   return ['e017f1c0' , '43de735f' , 'aada46cb' , 'ccfabee3','0432f141','0bbac3f1', '0d29511e', '8ab1af07', 'ced3e648','a7b77c92', '7900e957'].includes(this.stream.publicIdentity)
  
  }
  
   tickTimer:any = null

   ngOnInit() {

	if(!this.countData?.start){
		return
	}

	const countDownDate = this.countData.showDate

	if(countDownDate <= this.countData.nowDate){
		return
	}

	// keep the countdown on real time: browsers throttle timers in background tabs,
	// so counting ticks makes the timer drift and outlive the announced start
	const serverOffset = this.countData.nowDate - Date.now()

	const tick = () => {

		const distance = countDownDate - (Date.now() + serverOffset);

		const days = Math.floor(distance / (1000 * 60 * 60 * 24));
		const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((distance % (1000 * 60)) / 1000);

		this.days = days > 0 ? days : 0
		this.hours = hours > 0 ? hours : 0
		this.minutes = minutes > 0 ? minutes : 0
		this.seconds = seconds > 0 ? seconds : 0

		if(!this.init){this.init = true}

		if (distance < 0) {
			this.stopTicking()
			this.onDone.emit(true)
		}
	}

	tick()
	this.tickTimer = setInterval(tick, 1000);

  }

  stopTicking(){
	if(this.tickTimer){
		clearInterval(this.tickTimer)
		this.tickTimer = null
	}
  }

  ngOnDestroy() {
	this.stopTicking()
  }

}
